module.exports = __webpack_public_path__ + "static/media/chard.5b1bcf34.png";